import { queryOptions, useQuery } from '@tanstack/react-query';

import { getOneRosterUser } from '@/actions/auth';

export const oneRosterUserQueryKey = ['oneRosterUser'];

export const oneRosterUserQueryOptions = () =>
  queryOptions({
    queryKey: oneRosterUserQueryKey,
    queryFn: getOneRosterUser,
    retry: 3,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

export const useOneRosterAuthQuery = () => {
  return useQuery(oneRosterUserQueryOptions());
};
